<template>
  <form class="form form-loyalty-signup-terms mb-0" @submit.prevent="postTerms">

    <div class="form-group">
      <label>Podpis Właściciela:</label>
      <div class="signature">
        <ion-button mode="ios"
                    fill="outline"
                    size="small"
                    @click="clearSign('signatureContractor')"
                    class="btn">Wyczyść
        </ion-button>
        <vue-signature-pad width="100%"
                         height="200px"
                         ref="signatureContractor"
                         saveType="image/png">
        </vue-signature-pad>
      </div>
      <p class="error"
         v-if="errors['contractor_data.sign']"
         v-text="errors['contractor_data.sign'][0]">
      </p>
    </div>

    <div class="form-group">
      <label>Podpis Przedstawiciela:</label>
      <div class="signature">
        <ion-button mode="ios"
                    fill="outline"
                    size="small"
                    @click="clearSign('signatureSales')"
                    class="btn">Wyczyść
        </ion-button>
        <vue-signature-pad width="100%"
                         height="200px"
                         ref="signatureSales"
                         saveType="image/png">
        </vue-signature-pad>
      </div>
      <p class="error"
         v-if="errors['sales_representative_data.sign']"
         v-text="errors['sales_representative_data.sign'][0]">
      </p>
    </div>

    <slide-y-up-transition :duration="500" :delay="400">
      <div v-if="show">
        <ion-button mode="ios"
                    fill="outline"
                    size="small"
                    @click="goToStep(2)"
                    class="mt-10">Wstecz
        </ion-button>
        <ion-button mode="ios"
                    size="small"
                    @click="postTerms"
                    class="mt-10">Przejdź dalej
        </ion-button>
      </div>
    </slide-y-up-transition>
  </form>
</template>

<script>
  import { createHelpers } from 'vuex-map-fields';
  import VueSignaturePad from 'vue-signature-pad';
  import {mapState} from "vuex";

  const { mapFields } = createHelpers({
    getterType: `loyalty/getField`,
    mutationType: `loyalty/updateField`,
  });

  export default {
    name: 'FormLoyaltySignupActivationSigns',
    computed: {
      ...mapFields({
        signatureContractorData: 'signupActivationForm.contractor_data.sign',
        signatureSalesData: 'signupActivationForm.sales_representative_data.sign',
      }),
      ...mapState({
        errors: state => state.loyalty.errors,
      }),
    },
    data() {
      return {
        show: false,
      }
    },
    mounted(){
      this.show = true
    },
    methods: {
      saveSignatures() {
        let contractor = this.$refs.signatureContractor.saveSignature()
        let sales = this.$refs.signatureSales.saveSignature()
        // remove ".data" object after save
        this.signatureContractorData = contractor.data
        this.signatureSalesData = sales.data
      },
      clearSign(pad) {
        this.$refs[pad].clearSignature()
      },
      goToStep(step){
        this.$store.commit('loyalty/LOYALTY_SET_SIGNUP_ACTIVATION_CURRENT_STEP', step)
      },
      postTerms(){
        this.saveSignatures() // this MUST happen before request
        setTimeout(() => {
          this.$store.dispatch('loyalty/LOYALTY_CONTRACT_ACTIVATION_STORE_REQUEST', 4)
        },100)
      }
    }
  }
</script>

<style lang="scss" scoped>
  .signature{
    position: relative;
    .btn{
      position: absolute;
      top: 5px;
      right: 5px;
    }
  }
</style>